import { EllipsisVertical, KeySquare, Search } from "lucide-react";
import {
  handleFetchMatched,
  handleUpdateLeft,
  handleUpdateProgrammed,
} from "../../../api/vehicles";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Button, Input, Popover, message } from "antd";
import { useState } from "react";
import { DeleteOutlined } from "@ant-design/icons";

export default function Matched() {
  const [keyword, setKeyword] = useState<string>("");
  const queryClient = useQueryClient();
  const { data: vehicles } = useQuery({
    queryKey: ["vehicles", "matched", keyword],
    queryFn: () => handleFetchMatched({ keyword, match: true }),
  });

  const { mutate, isPending } = useMutation({
    mutationFn: handleUpdateProgrammed,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vehicles", "matched"] });
      queryClient.invalidateQueries({ queryKey: ["vehicles", "programmed"] });
      queryClient.invalidateQueries({ queryKey: ["vehicles", "unprogrammed"] });
      message.success("Vehicle marked as programmed");
    },
    onError: (error) => {
      message.error(`${error}`);
    },
  });

  const { mutate: mutateLeft, isPending: isPendingLeft } = useMutation({
    mutationFn: handleUpdateLeft,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vehicles", "matched"] });
      queryClient.invalidateQueries({ queryKey: ["vehicles", "programmed"] });
      queryClient.invalidateQueries({
        queryKey: ["vehicles", "unprogrammed"],
      });
      message.success("Vehicle marked as left");
    },
    onError: (error) => {
      message.error(`${error}`);
    },
  });

  const handleMarkAsProgrammed = (vehicle: any) => {
    mutate({ _id: vehicle?._id });
  };

  const handleMarkAsLeft = (vehicle: any) => {
    mutateLeft({ _id: vehicle?._id });
  };

  const content = (
    <div>
      <p>Are you sure you want to mark this vehicle as programmed?</p>
    </div>
  );

  return (
    <div className="">
      <div className="text-center text-gray-500 border-x border-t border-b-4 border-blue-300 p-2 bg-blue-200">
        <span className="font-bold">{vehicles?.total}</span> Vehicles Matched
        (Still In the Area)
      </div>
      <div className="p-1 bg-blue-100 border border-gray-200">
        <Input
          placeholder="Search Reg Number or VIN Number"
          value={keyword}
          prefix={<Search size={12} className="text-gray-500" />}
          onChange={(e: any) => setKeyword(e.target.value)}
          allowClear
          onPressEnter={(e: any) => setKeyword(e.target.value)}
        />
      </div>
      {vehicles?.records?.map((vehicle: any) => (
        <div
          key={vehicle._id}
          className="flex items-center justify-between border p-1 text-xxs"
        >
          <div>{vehicle.regNumber}</div>
          <div className="flex items-center gap-x-2">
            <div>{vehicle.vinNumber}</div>
            <Popover
              placement="top"
              title={
                <div className="flex items-center gap-x-1">
                  Mark as Programmed :
                  <span className="text-gray-500 text-xs font-bold">
                    ({vehicle.regNumber})
                  </span>
                </div>
              }
              content={content}
            >
              <Button
                type="primary"
                className="bg-red-100 text-red-500"
                size="small"
                onClick={() => handleMarkAsProgrammed(vehicle)}
                disabled={isPending}
              >
                <KeySquare size={12} /> Not Programmed
              </Button>
            </Popover>
            <button>
              <Popover
                placement="leftBottom"
                title={"Action"}
                content={
                  <div className="flex">
                    <button
                      onClick={(e: any) => {
                        e.stopPropagation();
                        handleMarkAsLeft(vehicle);
                      }}
                      className="border py-1 px-2 mx-1 flex items-center bg-red-50 text-red-800 shadow-sm"
                    >
                      <DeleteOutlined />
                      <span className="mx-1">
                        Vehicle Left without being programmed
                      </span>
                    </button>
                  </div>
                }
              >
                <button
                  onClick={(e: any) => e.stopPropagation()}
                  className="shadow-sm"
                >
                  <EllipsisVertical size={15} />
                </button>
              </Popover>
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
